import disableDevtool from "disable-devtool";

import { initializeMiddlewareUrl } from '@/utils/middlewareAvailability';

const isProd = process.env.NODE_ENV === "production";
const enableConfigJS = process.env.VUE_APP_CONFIGJS == "true";
const enableAntiDebuggingByEnv = process.env.VUE_APP_DEBUGGING == "true";

(async () => {
  try {
    if (!isProd || !enableConfigJS) {
      const res = await import('./config/index.js');
      if (typeof window !== 'undefined') {
        window.EZ_CONFIG = res.config || res.default || res;
      }
    }
    
    // 反调试逻辑：优先读取 index.js，环境变量作为兼容配置。
    const securityConfig = window.EZ_CONFIG?.SECURITY_CONFIG || {};
    const enableAntiDebugging = securityConfig.enableAntiDebugging ?? enableAntiDebuggingByEnv;

    if (isProd && enableAntiDebugging) {
      disableDevtool({
        url: securityConfig.antiDebuggingRedirectUrl || 'about:blank',
        disableMenu: true,
        clearLog: true
      });
    }
    
    await initializeMiddlewareUrl();

    // ⚠️ 确保在 config 加载后再初始化应用
    await import('./appInit.js');
  } catch (error) {
    console.error(error);
  }
})();
